module.exports = __webpack_public_path__ + "img/fpay-theme-white.9cdd90e7.png";